import React from "react";
import { ShieldCheck, Users, Globe } from "lucide-react";

const WhyICSSection = () => {
  const benefits = [
    {
      icon: ShieldCheck,
      title: "Shariah-First, Not Shariah-Optional",
      description: "We prioritize adherence to Islamic finance principles in all our research and discussions. Compliance is foundational, not an afterthought.",
    },
    {
      icon: Users,
      title: "Community Over Algorithms",
      description: "Real people, peer review, and thoughtful discussion instead of anonymous signals or automated recommendations.",
    },
    {
      icon: Globe,
      title: "Multi-Market Coverage: US, PSX, Commodities & Crypto",
      description: "Deep focus on US equities, Pakistan Stock Exchange, Commodities, and Crypto markets. Quality research across diverse asset classes.",
    },
  ];

  return (
    <section
      id="why-ics"
      data-testid="why-ics-section"
      className="py-20 md:py-32 bg-ics-navy-mid"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="section-divider mx-auto" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-4">
            Why ICS?
          </h2>
          <p className="text-ics-gray max-w-2xl mx-auto">
            What sets Investment Circle Shariah apart from other investment communities.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              data-testid={`why-ics-card-${index}`}
              className="text-center"
            >
              <div className="feature-icon mx-auto mb-6 w-16 h-16">
                <benefit.icon className="w-8 h-8" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-ics-white mb-3">
                {benefit.title}
              </h3>
              <p className="text-ics-gray text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyICSSection;
